/* import __COLOCATED_TEMPLATE__ from './group-navigation.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "",
});
